import type { ThemeConfig } from "antd";

export const appTheme: ThemeConfig = {
  token: {
    colorPrimary: "#ff2d55",
    colorInfo: "#ff2d55",
    colorSuccess: "#2f855a",
    colorWarning: "#d97706",
    colorError: "#c2413b",
    colorText: "#1c1f23",
    colorTextSecondary: "rgba(28, 31, 35, 0.62)",
    colorBgLayout: "#f0f0ef",
    colorBgContainer: "#ffffff",
    colorBorder: "rgba(23, 23, 23, 0.08)",
    borderRadius: 8,
    borderRadiusLG: 12,
    fontFamily: "'PingFang SC', 'Hiragino Sans GB', 'Noto Sans SC', 'Microsoft YaHei', sans-serif",
    controlHeight: 40,
  },
  components: {
    Button: {
      primaryShadow: "none",
      fontWeight: 600,
      borderRadius: 8,
    },
    Card: {
      boxShadow: "none",
    },
    Menu: {
      itemBorderRadius: 8,
      itemSelectedBg: "rgba(255, 45, 85, 0.12)",
      itemSelectedColor: "#d51f45",
    },
    Table: {
      headerBg: "#f4f4f2",
      headerColor: "rgba(28, 31, 35, 0.72)",
      rowHoverBg: "#ebebe8",
    },
  },
};
